<template >
  <div
    class="form-group formways-component formways-file"
    :class="ctx.customClass"
    v-if="!ctx.hidden"
  >
    <label :for="ctx.key">
      {{ ctx.label }}
      <span v-if="ctx.validate.required" class="text-danger">*</span>
      <i
        v-if="ctx.tooltip"
        class="fa fa-question-circle"
        aria-hidden="true"
        data-toggle="tooltip"
        data-placement="right"
        :title="ctx.tooltip"
      ></i>
    </label>
    <pre-loaded-files
      :files="value"
      @delete-file="markPrefilledFileForDeletion"
    />
    <div :id="ctx.key" ref="uploader" v-if="isUploaderVisible"></div>
    <!-- For disabled file uploder -->
    <div
      :id="ctx.key + 'disabled'"
      v-if="ctx.disabled"
      class="qq-uploader not-allowed"
    >
      <button type="button" class="btn btn-primary not-allowed" disabled>
        Upload a file
      </button>
    </div>
    <!-- end for disabled file uploader -->
    <small :id="ctx.key + 'Help'" class="form-text text-muted">
      {{ ctx.description }}
    </small>
  </div>
</template>

<script>
import Vue from 'vue';
import qq from 'fine-uploader/lib/s3';
import FieldMixin from '../../mixins/FieldMixin';
import 'fine-uploader/s3.fine-uploader/fine-uploader-new.css';
import { readableToBytes, debug } from '../../utils';
import preLoadedFiles from './preLoadedFiles.vue';
import defaultSchema from './fileDefaultSchema';

export default {
  name: 'file',
  mixins: [FieldMixin],
  components: {
    preLoadedFiles
  },
  data() {
    return {
      isPrefilledFilesPresent: {
        type: Boolean,
        default: false
      }
    };
  },
  computed: {
    isUploaderVisible() {
      if (this.ctx.disabled || this.ctx.hidden) return false;
      const currentFileCount = this.value.reduce(
        (total, x) => (x.url && !x.isDeleted ? total + 1 : total),
        0
      );
      debug.log('file count:', currentFileCount);
      if (this.ctx.multiple === false && currentFileCount > 0) return false;
      return true;
    }
  },
  watch: {
    isUploaderVisible(newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        setTimeout(() => {
          this.initFineUploader();
        }, 30);
      }
    }
  },
  beforeCreate() {
    // Default schema
    this.defaultSchema = defaultSchema;
  },
  created() {
    this.initFieldValue();
  },
  mounted() {
    if (this.isUploaderVisible) this.initFineUploader();
  },
  methods: {
    markPrefilledFileForDeletion(resourceId) {
      const deletedFile = this.value.findIndex(
        file => file.resourceId === resourceId
      );
      Vue.set(this.value[deletedFile], 'isDeleted', true);
    },
    initFineUploader() {
      const self = this;
      // Ref: https://docs.fineuploader.com/branch/master/api/options.html
      self.uploader = new qq.s3.FineUploader({
        element: self.$refs.uploader,
        validation: {
          allowedExtensions: self.ctx.fileTypes.map(item => item.value),
          minSizeLimit: readableToBytes(self.ctx.fileMinSize),
          sizeLimit: readableToBytes(self.ctx.fileMaxSize),
          itemLimit: self.ctx.multiple ? 0 : 1
        },
        request: {
          endpoint: `https://${self.context.s3.bucketName}.s3.amazonaws.com`,
          accessKey: self.context.s3.awsAccessKey
        },

        deleteFile: {
          enabled: true, // defaults to false
          endpoint: self.context.s3.signRequestEndpoint
        },

        signature: {
          endpoint: self.context.s3.signRequestEndpoint,
          version: 4
        },

        objectProperties: {
          region: 'ap-south-1',
          key(fileId) {
            let filename = self.uploader.getName(fileId);
            const uuid = self.uploader.getUuid(fileId);
            const ext = filename.substr(filename.lastIndexOf('.') + 1);
            filename = filename.substr(0, filename.lastIndexOf(`.${ext}`));
            return `${self.context.collegeCode}/${self.context.s3.folder}/${filename}-${uuid}.${ext}`;
          }
        },
        callbacks: {
          onError(id, name, errorReason) {
            if (errorReason.toLowerCase().indexOf('policy expired') !== -1) {
              /* global $ */
              $.simpleDialog({
                title: 'Incorrect System Time',
                message:
                  'Your system date and/or time is incorrect. Please correct it and click retry to upload the file.'
              });
            }
          },

          onComplete(fileId, name) {
            const fileInfo = {
              name,
              key: self.uploader.getKey(fileId),
              bucket: self.uploader.getBucket(fileId)
            };
            Vue.set(self.value, self.value.length, fileInfo);
          },

          onDeleteComplete(deletedFileId) {
            let filename = self.uploader.getName(deletedFileId);
            const uuid = self.uploader.getUuid(deletedFileId);
            const ext = filename.substr(filename.lastIndexOf('.') + 1);
            filename = filename.substr(0, filename.lastIndexOf(`.${ext}`));
            const key = `${self.context.collegeCode}/${self.context.s3.folder}/${filename}-${uuid}.${ext}`;
            const deletedIndex = self.value.findIndex(file => file.key === key);

            if (deletedIndex > -1) {
              self.value.splice(deletedIndex, 1);
            }
          }
        }
      });
    },
    reset() {
      this.uploader.clearStoredFiles();
      this.value = [];
      this.initFieldValue();
    }
  }
};
</script>
